module.exports = "https://www.gc-pro.gnp.com.mx/6208b59ccdf289c0f3bda6811962eac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/facturas/2.png
// module id = 1032
// module chunks = 0 1